// This File is to allow for support with the new TL syntax, please keep this up to date as keys.txt changes,
// or if we want to update the text on a string
// we have a tool that will build a legacyi18nObject using this mapping
// the tool is buildLegacyI18n in @bingads-webui-campaign/smart-i18n
// this file is exported separately, because we don't want the _TL_ syntax in the main exported code,
// as it breaks if not running through the bundler
export const legacyStrings = {
  Notification_lightbox_Coupon_Title_Signup_Success: _TL_(
    'Special offer: Turn {{upfrontSpend}} into {{value}} worth of advertising credits on Microsoft Advertising',
    {
      comment: '{{value}} is the value(with currency) of the free advertising they get. {{upfrontSpend}} is the amount the user needs to spend before getting the coupon value.',
    }
  ),
  Notification_lightbox_Coupon_Message_SmartSignup_Success: _TL_(
    'To unlock this limited-time offer, you\'ll need to spend {{upfrontSpend}} in advertising by {{expireDate}}.',
    {
      comment: '{{upfrontSpend}} is the amount the user needs to spend before getting the coupon value. {{expireDate}} is the date they need to spend the upfront spending by to get the coupon value.',
    }
  ),
  Notification_lightbox_Coupon_Message_SmartSignup_SuccessTaxable: _TL_(
    'To unlock this limited-time offer, you\'ll need to spend {{upfrontSpend}} (excluding taxes) in advertising by {{expireDate}}.',
    {
      comment: '{{upfrontSpend}} is the amount the user needs to spend before getting the coupon value. {{expireDate}} is the date they need to spend the upfront spending by to get the coupon value.',
    }
  ),
  Brief_SignupEvent: _TL_('Welcome to Microsoft Advertising!'),
  Notification_lightbox_Coupon_Title_SmartSignup_RedeemFailed: _TL_('Try redeeming your promotional code again'),
  Notification_lightbox_Coupon_Message_SmartSignup_RedeemFailed: _TL_(
    'We encountered a snag while redeeming your promotional code. Sorry about that! Please try again on the Promotions page by {{expireDate}}.',
    {
      comment: '{{expireDate}} is the date they need to redeem the coupon by.',
    }
  ),
  Notification_lightbox_Coupon_Title_SmartSignup_TimeLimitExceeded: _TL_('This promotional offer is no longer available'),
  Notification_lightbox_Coupon_Message_SmartSignup_TimeLimitExceeded: _TL_(
    'This promotional code can no longer be redeemed because the offer window has closed. New customer offers must be redeemed within a limited time after your account is created. {{offerLinkStart}}Offer details{{offerLinkStop}}',
    {
      comment: '{{offerLinkStart}} and {{offerLinkStop}} are html tags for linking to the coupon offer details. Shown when redemption fails because the acquisition-coupon time limit has passed.',
    }
  ),
  Notification_lightbox_Coupon_Message_Signup_Failure_PreviouslyAdvertised: _TL_(
    'Because you advertised with us before, you don\'t qualify for a new customer offer. {{offerLinkStart}}Offer details{{offerLinkStop}}',
    {
      comment: '{{offerLinkStart}} and {{offerLinkStop}} are html tags for linking to the coupon offer details.',
    }
  ),
  Notification_lightbox_Coupon_Message_Signup_Failure_Generic: _TL_(
    'We\'re sorry, you don\'t qualify for a new customer offer. {{offerLinkStart}}Offer details{{offerLinkStop}}',
    {
      comment: '{{offerLinkStart}} and {{offerLinkStop}} are html tags for linking to the coupon offer details.',
    }
  ),
  Notification_lightbox_Coupon_Title_Signup_Failure_ContactSupport: _TL_('Contact us to get your promotional code'),
  Notification_lightbox_Coupon_Message_Signup_Failure_ContactSupport: _TL_(
    'We encountered a snag while printing your promotional code. Sorry about that! Please {{supportLinkStart}}contact support{{supportLinkStop}} to get your promotional code. {{offerLinkStart}}Offer details{{offerLinkStop}}',
    {
      comment: '{{supportLinkStart}} and {{supportLinkStop}} are html tags for linking to contact us support page. {{offerLinkStart}} and {{offerLinkStop}} are html tags for linking to the coupon offer details.',
    }
  ),
  Notification_lightbox_Coupon_SubMessage_TimeIsTicking: _TL_(
    'Time is ticking. Act now! {{offerLinkStart}}Offer details{{offerLinkStop}}',
    {
      comment: '{{offerLinkStart}} and {{offerLinkStop}} are html tags for linking to the coupon offer details.',
    }
  ),
  Notification_lightbox_Continue: _TL_('Continue'),
  Notification_lightbox_GotIt: _TL_('Got it!'),
  Notification_lightbox_Coupon_Message_MSANSignup_Success: _TL_(
    'To unlock this limited-time offer, you\'ll need to spend {{upfrontSpend}} in Microsoft Audience Network campaigns by {{expireDate}}.',
    {
      comment: '{{upfrontSpend}} is the amount the user needs to spend in Microsoft Audience Network campaigns before getting the coupon value. {{expireDate}} is the date they need to spend the upfront spending by to get the coupon value.',
    }
  ),
  Notification_lightbox_Coupon_Message_MSANSignup_SuccessTaxable: _TL_(
    'To unlock this limited-time offer, you\'ll need to spend {{upfrontSpend}} (excluding taxes) in Microsoft Audience Network campaigns by {{expireDate}}.',
    {
      comment: '{{upfrontSpend}} is the amount the user needs to spend in Microsoft Audience Network campaigns before getting the coupon value. {{expireDate}} is the date they need to spend the upfront spending by to get the coupon value.',
    }
  ),
};

export type LegacyStrings = typeof legacyStrings;
